<template>
  <footer id="footer">
    <div class="container">
     
    </div>
  </footer>
</template>

<script>
import { defineComponent, h } from 'vue';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default defineComponent({
  name: 'FooterComponent',
  extends: Bar,
  //mixins: [reactiveProp],
  components: {
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 320
    },
    cssClasses: {
      default: '',
      type: String
    },
  },

  setup(props) {
    const chartData = {
      labels: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      datasets: [
        {
          label: 'Sales',
          backgroundColor: '#79ea86',
          data: [10, 20, 30, 40, 50, 10, 20, 30, 40, 50, 20, 50],
        },
        {
          label: 'Credit Notes',
          backgroundColor: '#e75757',
          data: [20, 30, 10, 15, 25, 20, 30, 10, 15, 25, 20, 50],
        },
      ],
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0
        }
      },
      plugins: {
        legend: {
          display: false
        }
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: '#92959E'
          },
          grid: {
            display: false,
          }
        },
        y: {
          stacked: true,
          ticks: {
            color: '#92959E'
          },
          grid: {
            display: false, 
          }
        }
      },
    };

    // Return the render function
    return () => h(Bar, {
      chartData,
      chartOptions,
      chartId: "stackedBar",
      width: props.width,
      height: props.height,
      cssClasses: props.cssClasses,
    });
  },
});
</script>

<style>
/* Add your component's styles here if needed */
</style>
